import styled from 'styled-components';

const InstructionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default InstructionBox;
